import { NgModule } from '@angular/core';
import { MyPosFacade } from './my-pos.facade';

@NgModule({
  providers: [MyPosFacade],
})
export class MyPosModule {}
